import axios from 'axios';
import i18n from 'i18next';
import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import type {AsyncExportDataRequestBody, DataExportAcceptedResponseBody} from '../types/api/data';
import type {ApiContext} from './types';

export function createExportApi(ctx: ApiContext) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;

  return {
    postExport: (params: AsyncExportDataRequestBody) =>
      axios
        .post(`${BASE}/export`, params)
        .then((response) => {
          showNotification.success(i18n.t('page.datagrid.exportSuccessful'));
          return response.data as DataExportAcceptedResponseBody;
        })
        .catch(
          (error: {
            response?: {status?: number; data?: {errors?: {message?: string}[]}};
            message?: string;
          }) => {
            const status = error?.response?.status;
            const errorMessage = error?.response?.data?.errors?.[0]?.message ?? error?.message;

            match(status)
              .with(403, () => showNotification.error(i18n.t('general.notifications.noPermission')))
              .otherwise(() => showNotification.error(errorMessage));
          }
        ),
  };
}
